// User action Type
export const SET_AUCTION_TAGS_LIST = "SET_AUCTION_TAGS_LIST";
export const ADD_AUCTION_TAGS = "ADD_AUCTION_TAGS";
export const EDIT_AUCTION_TAGS = "EDIT_AUCTION_TAGS";
export const DELETE_AUCTION_TAGS = "DELETE_AUCTION_TAGS";
